import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  fetchTaskWorkflow,
  insertTaskWorkflow,
  insertTaskWorkflowCategory,
  removeTaskWorkflow,
  removeTaskWorkflowCategory,
} from "./task-workflow.api";
import { TaskWorkflowState } from "./task-workflow.entity";

export const getTaskWorkflow = createAsyncThunk("task-workflow/get", fetchTaskWorkflow);

export const createTaskWorkflowCategory = createAsyncThunk("task-workflow/category-create", insertTaskWorkflowCategory);

export const createTaskWorkflowItem = createAsyncThunk("task-workflow/item-create", insertTaskWorkflow);

export const deleteTaskWorkflowCategory = createAsyncThunk("task-workflow/category-delete", removeTaskWorkflowCategory);

export const deleteTaskWorkflowItem = createAsyncThunk("task-workflow/task-delete", removeTaskWorkflow);

const initialState: TaskWorkflowState = {
  list: [],
  loading: false,
};

const taskWorkflow = createSlice({
  name: "task-workflow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTaskWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTaskWorkflow.rejected, (state) => {
        state.loading = false;
      })
      .addMatcher(
        isAnyOf(getTaskWorkflow.fulfilled, createTaskWorkflowCategory.fulfilled, createTaskWorkflowItem.fulfilled, deleteTaskWorkflowCategory.fulfilled, deleteTaskWorkflowItem.fulfilled),
        (state, action) => {
          state.list = action.payload.data;
          state.loading = false;
        }
      );
  },
});

export default taskWorkflow.reducer;
